// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/auth/svc_authentication.proto (package com.diagnocat.auth, syntax proto3)
/* eslint-disable */

import { Empty, MethodKind } from "@bufbuild/protobuf";
import { AdminMFA_EnforceReq, AdminMFA_StatusResp, AdminMFA_UserReq, AuthState, MFA_DisableReq, MFA_Enroll_BeginReq, MFA_Enroll_BeginResp, MFA_Enroll_ConfirmReq, MFA_Enroll_ConfirmResp, MFA_SignIn_VerifyReq, MFAStatus, Presign } from "./dto_auth_pb.js";
import { CheckInviteTokenReq, CheckInviteTokenResp, GetTTLsResp, LogoutReq, OrganizationAPIKey_CreateReq, OrganizationAPIKey_CreateResp, OrganizationAPIKey_DeleteReq, OrganizationAPIKey_DeleteResp, OrganizationAPIKey_ListReq, OrganizationAPIKey_ListResp, PasswordPolicy_GetReq, PasswordPolicy_GetResp, Recover_ByEmail_1_StartReq, Recover_ByEmail_2_SetPasswordReq, RefreshResp, SignInReq, SignUp_ByOneself_1_SendUserInfoReq, SignUp_ByOneself_2_ConfirmIdentityReq, SignUp_ByOneself_3_SetPasswordReq, SignUp_ViaOrganizationInviteReq, SignUp_ViaSalesmanInviteReq, SignUp_ViaSharedPatientReq, SignUp_ViaSharedPatientResp, UserPermissions_GetReq, UserPermissions_GetResp, UserPermissions_SetReq, UserPermissions_SetResp } from "./svc_authentication_pb.js";

/**
 * @generated from service com.diagnocat.auth.Authentication
 */
export const Authentication = {
  typeName: "com.diagnocat.auth.Authentication",
  methods: {
    /**
     * @generated from rpc com.diagnocat.auth.Authentication.GetState
     */
    getState: {
      name: "GetState",
      I: Empty,
      O: AuthState,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.auth.Authentication.CheckInviteToken
     */
    checkInviteToken: {
      name: "CheckInviteToken",
      I: CheckInviteTokenReq,
      O: CheckInviteTokenResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.auth.Authentication.Logout
     */
    logout: {
      name: "Logout",
      I: LogoutReq,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.auth.Authentication.Refresh
     */
    refresh: {
      name: "Refresh",
      I: Empty,
      O: RefreshResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.auth.Authentication.GetTTLs
     */
    getTTLs: {
      name: "GetTTLs",
      I: Empty,
      O: GetTTLsResp,
      kind: MethodKind.Unary,
    },
    /**
     *
     * UserBadRequestError:
     * - Code: email_taken (user with this email is already registered)
     *
     * @generated from rpc com.diagnocat.auth.Authentication.SignUp_ByOneself_1_SendUserInfo
     */
    signUp_ByOneself_1_SendUserInfo: {
      name: "SignUp_ByOneself_1_SendUserInfo",
      I: SignUp_ByOneself_1_SendUserInfoReq,
      O: AuthState,
      kind: MethodKind.Unary,
    },
    /**
     *
     * UserBadRequestError:
     * - Code: code_retries_limit (too many attempts)
     * - Code: code_is_expired (code lifetime exceeded)
     * - Code: wrong_code (code is incorrect)
     * - Code: already_registered (user is already registered)
     *
     * @generated from rpc com.diagnocat.auth.Authentication.SignUp_ByOneself_2_ConfirmIdentity
     */
    signUp_ByOneself_2_ConfirmIdentity: {
      name: "SignUp_ByOneself_2_ConfirmIdentity",
      I: SignUp_ByOneself_2_ConfirmIdentityReq,
      O: AuthState,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.auth.Authentication.SignUp_ByOneself_3_SetPassword
     */
    signUp_ByOneself_3_SetPassword: {
      name: "SignUp_ByOneself_3_SetPassword",
      I: SignUp_ByOneself_3_SetPasswordReq,
      O: AuthState,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.auth.Authentication.SignUp_ViaSharedPatient
     */
    signUp_ViaSharedPatient: {
      name: "SignUp_ViaSharedPatient",
      I: SignUp_ViaSharedPatientReq,
      O: SignUp_ViaSharedPatientResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.auth.Authentication.SignUp_ViaOrganizationInvite
     */
    signUp_ViaOrganizationInvite: {
      name: "SignUp_ViaOrganizationInvite",
      I: SignUp_ViaOrganizationInviteReq,
      O: AuthState,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.auth.Authentication.SignUp_ViaSalesmanInvite
     */
    signUp_ViaSalesmanInvite: {
      name: "SignUp_ViaSalesmanInvite",
      I: SignUp_ViaSalesmanInviteReq,
      O: AuthState,
      kind: MethodKind.Unary,
    },
    /**
     *
     * UserBadRequestError:
     * - Code: reset_invalid_creds (user with this email is already registered)
     *
     * @generated from rpc com.diagnocat.auth.Authentication.Recover_ByEmail_1_Start
     */
    recover_ByEmail_1_Start: {
      name: "Recover_ByEmail_1_Start",
      I: Recover_ByEmail_1_StartReq,
      O: AuthState,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.auth.Authentication.Recover_ByEmail_2_SetPassword
     */
    recover_ByEmail_2_SetPassword: {
      name: "Recover_ByEmail_2_SetPassword",
      I: Recover_ByEmail_2_SetPasswordReq,
      O: AuthState,
      kind: MethodKind.Unary,
    },
    /**
     *
     * NotFoundError:
     * - Entity: token
     *
     * @generated from rpc com.diagnocat.auth.Authentication.PasswordPolicy_Get
     */
    passwordPolicy_Get: {
      name: "PasswordPolicy_Get",
      I: PasswordPolicy_GetReq,
      O: PasswordPolicy_GetResp,
      kind: MethodKind.Unary,
    },
    /**
     *
     * UserBadRequestError:
     * - Code: ErrInvalidCreds (either password or email is wrong)
     * - Code: password_reset_required (a password set under the MFA minimum lost
     * its second factor; set a new one through password recovery)
     *
     * @generated from rpc com.diagnocat.auth.Authentication.SignIn
     */
    signIn: {
      name: "SignIn",
      I: SignInReq,
      O: AuthState,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.auth.Authentication.SignInByPresign
     */
    signInByPresign: {
      name: "SignInByPresign",
      I: Presign,
      O: AuthState,
      kind: MethodKind.Unary,
    },
    /**
     * MFA (TOTP two-step verification).
     *
     * MFA_Enroll_Begin generates a pending TOTP secret. Two contexts:
     * - authenticated user session: self enrolment / re-setup (confirm replaces
     * the active credential and reissues recovery codes; replacing requires
     * CurrentCode). Refused for org- or report-scoped presign sessions;
     * - mid-authentication (AuthState.MFA == EnrollRequired): forced enrolment.
     *
     * MFA_Enroll_Confirm verifies the first code, activates the credential, and
     * returns ten single-use recovery codes exactly once. The enrolling session
     * becomes MFA-compliant; every OTHER session of the user loses compliance. 
     *
     * @generated from rpc com.diagnocat.auth.Authentication.MFA_Enroll_Begin
     */
    mFA_Enroll_Begin: {
      name: "MFA_Enroll_Begin",
      I: MFA_Enroll_BeginReq,
      O: MFA_Enroll_BeginResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.auth.Authentication.MFA_Enroll_Confirm
     */
    mFA_Enroll_Confirm: {
      name: "MFA_Enroll_Confirm",
      I: MFA_Enroll_ConfirmReq,
      O: MFA_Enroll_ConfirmResp,
      kind: MethodKind.Unary,
    },
    /**
     * Second sign-in step after `SignIn` returned `MFA == VerifyRequired`.
     * A recovery code completes the sign-in AND disables MFA (used code invalidated). 
     *
     * @generated from rpc com.diagnocat.auth.Authentication.MFA_SignIn_Verify
     */
    mFA_SignIn_Verify: {
      name: "MFA_SignIn_Verify",
      I: MFA_SignIn_VerifyReq,
      O: AuthState,
      kind: MethodKind.Unary,
    },
    /**
     * Disables MFA. Requires the current TOTP code. Refused for enforced users
     * and org- or report-scoped presign sessions; refused with
     * `mfa_disable_requires_longer_password` while the password was set under the
     * MFA minimum. 
     *
     * @generated from rpc com.diagnocat.auth.Authentication.MFA_Disable
     */
    mFA_Disable: {
      name: "MFA_Disable",
      I: MFA_DisableReq,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * Self MFA status. 
     *
     * @generated from rpc com.diagnocat.auth.Authentication.MFA_Status
     */
    mFA_Status: {
      name: "MFA_Status",
      I: Empty,
      O: MFAStatus,
      kind: MethodKind.Unary,
    },
    /**
     * Admin Security tab. Permissions:
     * Status: MFA_CanView. Enforce: MFA_CanEnforce. Remove: MFA_CanSetup.
     * On admin targets, Enforce needs MFA_CanEditAdmin instead of MFA_CanEnforce,
     * and Remove needs it in addition to MFA_CanSetup. 
     *
     * @generated from rpc com.diagnocat.auth.Authentication.AdminMFA_Status
     */
    adminMFA_Status: {
      name: "AdminMFA_Status",
      I: AdminMFA_UserReq,
      O: AdminMFA_StatusResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.auth.Authentication.AdminMFA_Enforce
     */
    adminMFA_Enforce: {
      name: "AdminMFA_Enforce",
      I: AdminMFA_EnforceReq,
      O: AdminMFA_StatusResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.auth.Authentication.AdminMFA_Remove
     */
    adminMFA_Remove: {
      name: "AdminMFA_Remove",
      I: AdminMFA_UserReq,
      O: AdminMFA_StatusResp,
      kind: MethodKind.Unary,
    },
    /**
     *
     * Lists the organization's API keys. The secret is never included.
     *
     * Permission: `OrganizationPermissions.APIKey_CanView` (organization owner (FullAccess role) or an admin with `AdminPermissions.APIKey_CanView`)
     *
     * @generated from rpc com.diagnocat.auth.Authentication.OrganizationAPIKey_List
     */
    organizationAPIKey_List: {
      name: "OrganizationAPIKey_List",
      I: OrganizationAPIKey_ListReq,
      O: OrganizationAPIKey_ListResp,
      kind: MethodKind.Unary,
    },
    /**
     *
     * Creates an organization API key and returns it, including the secret.
     * The secret is returned only once, on creation.
     *
     * Permission: `OrganizationPermissions.APIKey_CanCreate` (organization owner (FullAccess role) or an admin with `AdminPermissions.APIKey_CanCreate`)
     *
     * @generated from rpc com.diagnocat.auth.Authentication.OrganizationAPIKey_Create
     */
    organizationAPIKey_Create: {
      name: "OrganizationAPIKey_Create",
      I: OrganizationAPIKey_CreateReq,
      O: OrganizationAPIKey_CreateResp,
      kind: MethodKind.Unary,
    },
    /**
     *
     * Deletes an organization API key.
     *
     * Permission: `OrganizationPermissions.APIKey_CanDelete` (organization owner (FullAccess role) or an admin with `AdminPermissions.APIKey_CanDelete`)
     *
     * @generated from rpc com.diagnocat.auth.Authentication.OrganizationAPIKey_Delete
     */
    organizationAPIKey_Delete: {
      name: "OrganizationAPIKey_Delete",
      I: OrganizationAPIKey_DeleteReq,
      O: OrganizationAPIKey_DeleteResp,
      kind: MethodKind.Unary,
    },
    /**
     *
     * Returns the user's granular admin permissions. Side effect: refreshes the
     * per-user permissions cache in Redis. Called by the gate as a self-read on
     * cache miss.
     *
     * Permission: `UserID == caller` (self-read), or the caller's `AdminPermissions.AdminPermissions_CanEdit`
     *
     * @generated from rpc com.diagnocat.auth.Authentication.UserPermissions_Get
     */
    userPermissions_Get: {
      name: "UserPermissions_Get",
      I: UserPermissions_GetReq,
      O: UserPermissions_GetResp,
      kind: MethodKind.Unary,
    },
    /**
     *
     * Replaces the user's granular admin permissions. Absent Permissions.Admin
     * revokes admin access entirely and write-through updates the permissions
     * cache, so the change takes effect on the target's next request.
     *
     * Permission: the caller's `AdminPermissions.AdminPermissions_CanEdit`.
     * Anti-lockout: the caller cannot revoke their own AdminPermissions_CanEdit
     * (nor clear their own Admin block).
     *
     * @generated from rpc com.diagnocat.auth.Authentication.UserPermissions_Set
     */
    userPermissions_Set: {
      name: "UserPermissions_Set",
      I: UserPermissions_SetReq,
      O: UserPermissions_SetResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

